import React, { memo } from 'react'
import Link from 'root/src/client/web/base/Link'
import { LOGIN_ROUTE_ID } from 'root/src/shared/descriptions/routes/routeIds'

export default memo(({ signInPromptVisible, className, text, style }) => (
	signInPromptVisible && (
		<div {...{ className, style }}>
			<span><Link routeId={LOGIN_ROUTE_ID}>Sign In</Link> {text}</span>
		</div>
	)
))
